import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index.vue'
import Home from '../views/index/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      includeTarBar: true,
      title: '岳阳全域旅游'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      includeTarBar: true,
      title: '岳阳全域旅游'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  // 在这里执行你的拦截逻辑
  next()
})

export default router
